module.exports = __webpack_public_path__ + "static/media/open-sans-v15-latin-regular.bf2d0783.woff";